export default "__VITE_ASSET__e3da0ae9__"